module.exports = __webpack_public_path__ + "img/tooltip1.41096966.svg";